var map = {
	"./KROL/patients.json": 4140,
	"./SWC/patients.json": 4141
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4139;


//////////////////
// WEBPACK FOOTER
// ./data/sheets ^\.\/.*\/patients\.json$
// module id = 4139
// module chunks = 0